import { Tanium } from '../models/Tanium';

export class TaniumMapper {
  mapGQLModel(data: any) {
    return new Tanium(data.url, data.accessToken, data.trustedCaCertificate, data.maxConcurrentRetrievals, data.requestRate);
  }
}
